import Carga from '@/model/resource/Carga'
import ClientNotificationResponseCSVSchema from '@/schema/ClientNotificationResponseCSV.schema'

export default class ClientNotificationResponseCSV extends Carga {
    readonly $name: string = 'ClientNotificationResponseCSV'
    readonly $endpoint: string = '/user/indicador/client-notification/relatorio'

    get $schema() {
        return ClientNotificationResponseCSVSchema(this)
    }
}
